import React, { useMemo, useEffect } from "react";
import moment from "moment";

const Countdown: React.FC<{
    now?: string;
    endDateTime: string;
    onComplete: () => void;
}> = ({ now = moment(), endDateTime, onComplete }) => {
    const getZero = (num: number) => {
        return `0${num}`.slice(-2);
    };

    const isEnd = useMemo(() => {
        return moment(now).isSameOrAfter(endDateTime);
    }, [endDateTime, now]);

    useEffect(() => {
        isEnd && onComplete();
    }, [isEnd]);

    if (moment(endDateTime).diff(now, "days") > 0) {
        return <span>{moment(endDateTime).diff(now, "days")} 天</span>;
    }
    const duration = moment.duration(moment(endDateTime).diff(now));
    if (duration.asSeconds() <= 0) return <span>00:00:00</span>;
    return (
        <span>
            {getZero(duration.hours())}:{getZero(duration.minutes())}:
            {getZero(duration.seconds())}
        </span>
    );
};

export default Countdown;
